import React from "react";
import { observer, inject } from "mobx-react";
import { TablePageHeader } from "../../../components/TablePageHeader";
import { Row, Col, Table, Button, Form, Card, Tabs, Tab } from "react-bootstrap";
import { CustomerOrdersStore } from "../../../stores/CustomerOrdersStore";
import { STORE_CUSTOMER_ORDERS, STORE_REPORT1 } from "../../../constants";
import { formatMoney, formatShortDate } from "../../../common/Formatting";
import { wrapInput } from "../../../common/FormChangeWrapper";
import DatePicker, { registerLocale } from "react-datepicker";
import ru from 'date-fns/locale/ru';
import { MultiSelect } from "../../../common/UI/MultiSelect";
import { Report1Store } from "../../../stores";
import { NotificationLevel } from "../../../stores/NotificationStore";
import { BaseChart } from "./Charts/BaseChart";
import { ByUsersChart } from "./Charts/ByUsersChart";
import { SOURCES_ABTEKA, SOURCES_AS61, SOURCES_AB61 } from "../../../constants";
registerLocale('ru', ru)

interface IState {
    filterFormIsOpened: boolean;
    filteredManagerIds: string[];
    filteredSources: string[];
    filteredStatuses: number[];
    dateFrom?: Date;
    dateTo?: Date;
    payByPosition?: number;
    sumPercent?: number;
    openedChart: string;
}

@inject(STORE_CUSTOMER_ORDERS, STORE_REPORT1)
@observer
export class Report1Page extends React.Component<{}, IState> {
    constructor(props: {}) {
        super(props);
        this.state = {
            filterFormIsOpened: false,
            filteredManagerIds: [],
            filteredStatuses: [2],
            filteredSources: [SOURCES_AS61, SOURCES_AB61, SOURCES_ABTEKA],
            openedChart: "base"
        };
    }

    report1Store = (this.props as any)[STORE_REPORT1] as Report1Store;
    customerOrdersStore = (this.props as any)[STORE_CUSTOMER_ORDERS] as CustomerOrdersStore;


    loadData = () => {
        if (this.state.filteredSources == undefined || this.state.filteredSources.length <= 0)
            this.report1Store._rootStore.notificationStore.addNotification("Не указан источник!", NotificationLevel.error);
        else if (this.state.filteredStatuses == undefined || this.state.filteredStatuses.length <= 0)
            this.report1Store._rootStore.notificationStore.addNotification("Не указан статус!", NotificationLevel.error);
        else
            this.report1Store.loadData(this.state.filteredManagerIds, this.state.filteredSources, this.state.filteredStatuses, this.state.dateFrom, this.state.dateTo);
    }

    componentDidMount() {
        const savedFilter = JSON.parse(localStorage.getItem("report1Filter") || "{}");
        if (savedFilter.dateFrom != null) {
            savedFilter.dateFrom = new Date(savedFilter.dateFrom);
        }
        if (savedFilter.dateTo != null) {
            savedFilter.dateTo = new Date(savedFilter.dateTo);
        }

        this.setState(Object.assign({}, this.state, savedFilter), () => {
            this.customerOrdersStore.loadManagers();
            this.customerOrdersStore.loadStatuses();
        });
    }


    private toggleFilter = () => {
        const previousState = this.state.filterFormIsOpened;
        this.setState({
            filterFormIsOpened: !previousState
        });
    }
    private clearFilter = () => {
        this.setState({
            filteredManagerIds: [],
            filteredStatuses: [],
            filteredSources: [],
            dateFrom: undefined,
            dateTo: undefined
        });
        localStorage.removeItem("report1Filter");
    }

    private changeFilter = (name: string, value: any) => {

        (this as any).setState({
            [name]: value
        }, () => {
            this.saveFilterToLocalStorage();
        });
    }

    private saveFilterToLocalStorage = () => {
        if (this.state.filteredManagerIds == null
            && this.state.dateTo == null && this.state.dateFrom == null) {
            localStorage.removeItem("report1Filter");
            return;
        }
        localStorage.setItem("report1Filter", JSON.stringify({
            filteredManagerIds: this.state.filteredManagerIds,
            filteredSources: this.state.filteredSources,
            filteredStatuses: this.state.filteredStatuses,
            dateFrom: this.state.dateFrom,
            dateTo: this.state.dateTo,
            filterFormIsOpened: true,
            sumPercent: this.state.sumPercent,
            payByPosition: this.state.payByPosition,
        }));
    }




    render() {
        return [
            <TablePageHeader header="Отчет продаж по менеджерам" reload={this.loadData} key="1">
                <Form inline onSubmit={(e: any) => {
                    e.preventDefault();
                    this.loadData();
                }}>

                    <Button type="button" size="sm" variant="secondary" active={this.state.filterFormIsOpened} style={{ marginLeft: "15px" }} onClick={this.toggleFilter}>
                        Фильтр
                    </Button>
                </Form>

            </TablePageHeader>,
            this.state.filterFormIsOpened ?
                <Row key="filter">
                    <Col sm="12">
                        <Card bg="light" >
                            <Card.Body>
                                <Form>
                                    <Row>
                                        <Col sm="2">
                                            <Button variant="primary" size="sm" onClick={this.loadData}>Найти</Button>
                                            <Button
                                                variant="secondary"
                                                size="sm" style={{ marginLeft: "20px" }}
                                                onClick={this.clearFilter}>
                                                Очистить
                                            </Button>
                                            <Form.Group controlId="filterForm.SelectSource">
                                                <Form.Label>Источник</Form.Label>
                                                <MultiSelect
                                                    precheckedAll={false}
                                                    title="Источник"
                                                    data={[
                                                        { Key: SOURCES_AS61, Value: "As61.ru" },
                                                        { Key: SOURCES_AB61, Value: "Ab61.ru" },
                                                        { Key: SOURCES_ABTEKA, Value: "Abteka.ru" }
                                                    ]}
                                                    selectedItems={this.state.filteredSources}
                                                    onChange={(keys: string[]) => {
                                                        this.changeFilter("filteredSources", keys);
                                                    }}
                                                    width="100%"
                                                    size="sm"
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col sm="2">
                                            <Form.Group controlId="filterForm.SelectManager">
                                                <Form.Label>Ответственный</Form.Label>
                                                <MultiSelect
                                                    precheckedAll={false}
                                                    title="Фильтр по менеджеру"
                                                    data={this.customerOrdersStore.managers}
                                                    selectedItems={this.state.filteredManagerIds}
                                                    onChange={(keys: string[]) => {
                                                        this.changeFilter("filteredManagerIds", keys);
                                                    }}
                                                    width="100%"
                                                    size="sm"
                                                />
                                            </Form.Group>
                                            <Form.Group controlId="filterForm.SelectManager">
                                                <Form.Label>Статус</Form.Label>
                                                <MultiSelect
                                                    precheckedAll={false}
                                                    title="Статус"
                                                    data={this.customerOrdersStore.statuses.map(w => { return { Key: w.Key.toString(), Value: w.Value } })}
                                                    selectedItems={this.state.filteredStatuses.map(w => w.toString())}
                                                    onChange={(keys: string[]) => {
                                                        this.changeFilter("filteredStatuses", keys);
                                                    }}
                                                    width="100%"
                                                    size="sm"
                                                />
                                            </Form.Group>
                                        </Col>
                                        <Col sm="4">
                                            <Form.Group controlId="filterForm.DateFrom">
                                                <Form.Label>Дата с</Form.Label>
                                                <div>
                                                    <DatePicker
                                                        className="form-control form-control-sm"
                                                        locale="ru"
                                                        dateFormat="dd-MM-yyyy"
                                                        monthsShown={2}
                                                        openToDate={(new Date()).addMonth(-1)}
                                                        name="dateFrom"
                                                        autoComplete="off"
                                                        onChange={(date: Date | null) => {
                                                            this.changeFilter("dateFrom", date || undefined)
                                                        }}
                                                        selected={this.state.dateFrom}
                                                    />
                                                </div>
                                            </Form.Group>
                                            <Form.Group controlId="filterForm.DateTo">
                                                <Form.Label>Дата по</Form.Label>
                                                <div>
                                                    <DatePicker
                                                        className="form-control form-control-sm"
                                                        locale="ru"
                                                        dateFormat="dd-MM-yyyy"
                                                        maxDate={new Date()}

                                                        onChange={(date: Date | null) => {
                                                            if (date != undefined) {
                                                                date.setHours(23);
                                                                date.setMinutes(59);
                                                                date.setSeconds(59);
                                                            }
                                                            this.changeFilter("dateTo", date || undefined)
                                                        }}
                                                        selected={this.state.dateTo}
                                                    />
                                                </div>
                                            </Form.Group>
                                        </Col>
                                        <Col sm="2"></Col>
                                    </Row>
                                </Form>
                            </Card.Body>
                        </Card>
                        <br />
                    </Col>
                </Row> : [],
            <Row key={"table_2"}>
                <Col sm={5}>
                    <Table bordered className="table-xxs">
                        <thead>
                            <tr>
                                <th className="text-left">Менеджер</th>
                                <th className="text-center">Кол-во заказов</th>
                                <th className="text-center">Кол-во позиций</th>
                                <th className="text-center">Сумма</th>
                                <th className="text-center">Плата за позицию</th>
                                <th className="text-center">Процент от суммы</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                this.report1Store.totals.map((manager, index) => <tr key={'t_m_' + index}>
                                    <td className="text-left">{manager.managerName}</td>
                                    <td className="text-center">{manager.ordersCount}</td>
                                    <td className="text-center">{manager.positionsCount}</td>
                                    <td className="text-center">{formatMoney(manager.sum)}</td>
                                    <td className="text-center">
                                        {this.state.payByPosition ? formatMoney(manager.positionsCount * this.state.payByPosition) : ""}
                                    </td>
                                    <td className="text-center">
                                        {this.state.sumPercent ? formatMoney(manager.sum * (this.state.sumPercent / 100)) : ""}
                                    </td>
                                </tr>)
                            }
                        </tbody>
                        <tfoot>
                            <tr>
                                <td className="text-right">Итого:</td>
                                <th className="text-center">{this.report1Store.totals.reduce((a: number, b) => a + b.ordersCount, 0)}</th>
                                <th className="text-center">{this.report1Store.totals.reduce((a: number, b) => a + b.positionsCount, 0)}</th>
                                <th className="text-center">{formatMoney(this.report1Store.totals.reduce((a: number, b) => a + b.sum, 0))}</th>
                                <th className="text-center">
                                    {this.state.payByPosition ? formatMoney(this.report1Store.totals.reduce((a: number, b) => a + b.positionsCount, 0) * this.state.payByPosition) : ""}
                                </th>
                                <th className="text-center">
                                    {this.state.sumPercent ? formatMoney(this.report1Store.totals.reduce((a: number, b) => a + b.sum, 0) * this.state.sumPercent / 100) : ""}
                                </th>
                            </tr>
                        </tfoot>
                    </Table>
                </Col>
                <Col sm={7}>
                    <Tabs id="charts-tabs" activeKey={this.state.openedChart} onSelect={(k: any) => this.setState({
                        openedChart: k
                    })}>
                        <Tab eventKey="base" title="Базовый">
                            {this.state.openedChart == "base" ?
                                <BaseChart
                                    dateFrom={this.state.dateFrom || new Date().addMonth(-1)}
                                    dateTo={this.state.dateTo || new Date()}
                                    data={this.report1Store.items} /> : []
                            }
                        </Tab>
                        <Tab eventKey="byusers" title="По пользователям">
                            {this.state.openedChart == "byusers" ?
                                <ByUsersChart
                                    managers={this.customerOrdersStore.managers.filter(w => this.state.filteredManagerIds.indexOf(w.Key) > -1)}
                                    dateFrom={this.state.dateFrom || new Date().addMonth(-1)}
                                    dateTo={this.state.dateTo || new Date()}
                                    data={this.report1Store.items} /> : []
                            }
                        </Tab>
                    </Tabs>

                </Col>
            </Row >,
            <Row key="table_3">
                <Col sm={12}>
                    <Table bordered className="table-xxs">
                        <thead>
                            <tr>
                                <th className="text-center">Дата</th>
                                <th className="text-center">Заказов за дату</th>
                                <th className="text-center">Позиций за дату</th>
                                <th className="text-center">Сумма за дату</th>
                                <th className="text-left">Менеджер</th>
                                <th className="text-center">Кол-во заказов</th>
                                <th className="text-center">Кол-во позиций</th>
                                <th className="text-center">Сумма</th>
                                <th className="text-center">
                                    Плата за позицию
                                    <br />
                                    <Form.Control size="sm"
                                        type="number"
                                        style={{ margin: "2px auto", width: "60px", textAlign: "center" }}
                                        value={this.state.payByPosition == undefined ? "" : this.state.payByPosition.toString()}
                                        name="payByPosition"
                                        onChange={wrapInput(this.changeFilter)}
                                    />
                                </th>
                                <th className="text-center">
                                    Процент от суммы
                                    <br />
                                    <Form.Control size="sm"
                                        type="number"
                                        style={{ margin: "2px auto", width: "60px", textAlign: "center" }}
                                        value={this.state.sumPercent == undefined ? "" : this.state.sumPercent.toString()}
                                        name="sumPercent"
                                        onChange={wrapInput(this.changeFilter)}
                                    />
                                </th>
                            </tr>
                        </thead>

                        <tbody>
                            {
                                this.report1Store.items.filter(w => w.managers.length > 0).map((item, index) => {
                                    return [<tr key={index}>
                                        <td className="text-center" rowSpan={item.managers.length}>{formatShortDate(item.date)}</td>
                                        <td className="text-center" rowSpan={item.managers.length}>
                                            {item.managers.reduce((a: number, b) => a + b.ordersCount, 0)}
                                        </td>
                                        <td className="text-center" rowSpan={item.managers.length}>
                                            {item.managers.reduce((a: number, b) => a + b.positionsCount, 0)}
                                        </td>
                                        <td className="text-center" rowSpan={item.managers.length}>
                                            {formatMoney(item.managers.reduce((a: number, b) => a + b.sum, 0))}
                                        </td>
                                        <td className="text-left">{item.managers[0].managerName}</td>
                                        <td className="text-center">{item.managers[0].ordersCount}</td>
                                        <td className="text-center">{item.managers[0].positionsCount}</td>
                                        <td className="text-center">{formatMoney(item.managers[0].sum)}</td>
                                        <td className="text-center">
                                            {this.state.payByPosition ? formatMoney(item.managers[0].positionsCount * this.state.payByPosition) : ""}
                                        </td>
                                        <td className="text-center">
                                            {this.state.sumPercent ? formatMoney(item.managers[0].sum * (this.state.sumPercent / 100)) : ""}
                                        </td>
                                    </tr>, item.managers.length <= 0 ? [] : item.managers.slice(1).map((manager, subIndex) => <tr key={'m_' + index + '_' + subIndex}>
                                        <td className="text-left">{manager.managerName}</td>
                                        <td className="text-center">{manager.ordersCount}</td>
                                        <td className="text-center">{manager.positionsCount}</td>
                                        <td className="text-center">{formatMoney(manager.sum)}</td>
                                        <td className="text-center">
                                            {this.state.payByPosition ? formatMoney(manager.positionsCount * this.state.payByPosition) : ""}
                                        </td>
                                        <td className="text-center">
                                            {this.state.sumPercent ? formatMoney(manager.sum * (this.state.sumPercent / 100)) : ""}
                                        </td>
                                    </tr>)]
                                })
                            }

                        </tbody>
                    </Table>
                </Col>
            </Row >
        ]
    }
}